<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol col="12" xs="11" sm="11" md="10" lg="8" xl="6">
        <div class="w-100">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">404</h1>
          <h4 class="pt-3">Sorry, page not found</h4>
          <p class="text-muted">Terjadi kesalahan, halaman tidak ditemukan.</p>
        </div>
      </div>
      </CCol>
    </CRow>
  </CContainer>
</template>
<script>
export default {
  name: 'Page404',
  data() {
    return{
    }
  }
}
</script>
